import { connect } from 'react-redux';
import _get from 'lodash/get';
import { Layout } from '@casanova/casanova-common';
import { navigate } from 'store/app/actions';
import { logout } from 'store/auth/actions';
import ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';
import BranchSelector from '../BranchSelector';

const EnhancedLayout = (props) => {
  const [portal, setPortal] = useState(null);

  useEffect(() => {
    const targetContainer = document.querySelector('.col-header-user .branch .font-weight-bold.mr-2');
    if (targetContainer) {
      if(!document.getElementById('branchSelector')) {
        targetContainer.innerHTML = '';
      }
      setPortal(
        ReactDOM.createPortal(
          <BranchSelector {...props} />,
          targetContainer
        )
      );
    }
  }, [props]);

  return (
    <>
      {portal}
      <Layout {...props} />
    </>
  );
};

export default connect(
  (state) => {
    const userFullName = _get(state, 'auth.user.fullName');
    const userBranchUuid = _get(state, 'auth.user.branch', '');
    const userUuid = _get(state, 'auth.user.uuid', '');
    const branchCatalog = _get(state, 'commons.branches.list', []);
    const userBranch = branchCatalog.find(
      (branch) => branch.uuid === userBranchUuid
    );
    const userBranchName = _get(userBranch, 'shortName', '');    
    localStorage.setItem("br", userBranchUuid);
    localStorage.setItem("userUuid", userUuid);

    return {
      activeRoute: state.app.activeRoute,
      userFullName,
      userBranch: userBranchName || '',
      userUuid
    };
  },
  (dispatch) => ({
    onChangeRoute: (item, subItem) => dispatch(navigate(item, subItem)),
    logout: () => dispatch(logout()),
  })
)(EnhancedLayout);
